import React from "react";

const CaseStudyShowcase = () => {

    const studies = [
        {
            title: "FinFlow Platform",
            category: "FinTech",
            result: "+320% Growth",
            tech: ["React", "Node", "AWS"],
            large: true,
        },
        {
            title: "MediCare App",
            category: "Healthcare",
            result: "120K Users",
            tech: ["Flutter", "Firebase"],
        },
        {
            title: "LearnHub",
            category: "Education",
            result: "80K Students",
            tech: ["React Native"],
        },
        {
            title: "ShopVerse",
            category: "E-Commerce",
            result: "+280% Revenue",
            tech: ["Next.js", "Stripe"],
            large: true,
        },
        {
            title: "LogiTrack",
            category: "Logistics",
            result: "40% Faster",
            tech: ["Laravel", "React"],
        },
        {
            title: "FoodGo",
            category: "Food Delivery",
            result: "500K Orders",
            tech: ["Flutter", "Node"],
        },
    ];

    return (
        <>
            <section className="css-section">

                <div className="css-container">

                    <div className="css-header">

                        <span>CASE STUDY SHOWCASE</span>

                        <h2>
                            Projects That
                            <br />
                            Made An Impact
                        </h2>

                        <p>
                            Explore a selection of digital products
                            crafted by AppVerseLabs across multiple
                            industries and platforms.
                        </p>

                    </div>

                    <div className="css-grid">

                        {studies.map((item, index) => (

                            <div
                                key={index}
                                className={`css-card ${item.largew
                                        ? "largew"
                                        : ""
                                    }`}
                            >

                                <div className="css-image">

                                    <div className="css-category">
                                        {item.category}
                                    </div>

                                    <div className="css-result">
                                        {item.result}
                                    </div>

                                </div>

                                <div className="css-content">

                                    <h3>
                                        {item.title}
                                    </h3>

                                    <div className="css-tech">

                                        {item.tech.map((tech, i) => (
                                            <span key={i}>
                                                {tech}
                                            </span>
                                        ))}

                                    </div>

                                    <a href="#">
                                        View Project →
                                    </a>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

                <style>{`

                .css-section{
                    padding:150px 24px;
                    background:#fff;
                }

                .css-container{
                    max-width:1400px;
                    margin:auto;
                }

                .css-header{
                    text-align:center;
                    margin-bottom:80px;
                }

                .css-header span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;
                    margin-bottom:24px;
                }

                .css-header h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    
                    color:#111;
                        text-align: center;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                }

                .css-header p{
                    max-width:700px;
                    margin:auto;
                        text-align: center;
                    color:#666;
                    font-size:18px;
                    line-height:1.9;
                }

                .css-grid{
                    display:grid;
                    grid-template-columns:
                    repeat(3,1fr);
                    gap:28px;
                }

                .css-card{
                    background:#fff;
                    border-radius:32px;
                    overflow:hidden;
                    border:1px solid #eee;
                    transition:.45s ease;
                    box-shadow:
                    0 15px 40px rgba(0,0,0,.05);
                }

                .css-card:hover{
                    transform:translateY(-10px);
                    border-color:#E8212A;
                    box-shadow:
                    0 30px 80px rgba(232,33,42,.12);
                }

                .css-card.large{
                    grid-row:span 2;
                }

                .css-image{
                    position:relative;
                    height:260px;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    overflow:hidden;
                }

                .css-card.large .css-image{
                    height:420px;
                }

                .css-image::before{
                    content:"";
                    position:absolute;
                    width:350px;
                    height:350px;
                    border-radius:50%;
                    background:
                    rgba(255,255,255,.08);
                    top:-120px;
                    right:-120px;
                }

                .css-image::after{
                    content:"";
                    position:absolute;
                    width:220px;
                    height:220px;
                    border-radius:50%;
                    border:1px solid
                    rgba(255,255,255,.12);
                    bottom:-100px;
                    left:-80px;
                }

                .css-category{
                    position:absolute;
                    top:24px;
                    left:24px;

                    padding:10px 18px;
                    border-radius:999px;

                    background:
                    rgba(255,255,255,.14);

                    backdrop-filter:blur(10px);

                    color:#fff;
                    font-size:12px;
                    font-weight:700;
                }

                .css-result{
                    position:absolute;
                    bottom:24px;
                    left:24px;

                    color:#fff;
                    font-size:30px;
                    font-weight:800;

                    font-family:'Syne',sans-serif;
                }

                .css-content{
                    padding:32px;
                }

                .css-content h3{
                    font-size:34px;
                    margin-bottom:18px;
                    color:#111;
                    line-height:1;
                    font-family:'Syne',sans-serif;
                }

                .css-tech{
                    display:flex;
                    gap:10px;
                    flex-wrap:wrap;
                    margin-bottom:25px;
                }

                .css-tech span{
                    padding:9px 14px;
                    border-radius:999px;
                    background:#f5f5f5;
                    font-size:13px;
                    color:#444;
                    font-weight:600;
                }

                .css-content a{
                    color:#E8212A;
                    text-decoration:none;
                    font-weight:700;
                }

                @media(max-width:1100px){

                    .css-grid{
                        grid-template-columns:
                        repeat(2,1fr);
                    }

                }

                @media(max-width:768px){

                    .css-section{
                        padding:100px 18px;
                    }

                    .css-grid{
                        grid-template-columns:1fr;
                    }

                    .css-card.large{
                        grid-row:auto;
                    }

                    .css-card.large .css-image{
                        height:260px;
                    }

                    .css-header h2{
                        letter-spacing:-2px;
                    }

                    .css-content h3{
                        font-size:28px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default CaseStudyShowcase;